/**
 * Enum for pin manager.
 * @readonly
 * @enum {String} PinManagerEnum
 */

const PinManagerEnum = {
  PosDiscount                   : 'PosDiscount',
  PosCancel                     : 'PosCancel',
  PosRevert                     : 'PosRevert',
  PosDelete                     : 'PosDelete',
  PosEdit                       : 'PosEdit',
  PosPayments                   : 'PosPayments',
  PosSetCustomPrice             : 'PosSetCustomPrice',
  PosChangeOrderTimeDuringAccept: 'PosChangeOrderTimeDuringAccept',
  PosChangeOrderTimeAfterAccept : 'PosChangeOrderTimeAfterAccept',
  PosTransactionManualAccept    : 'PosTransactionManualAccept',
  PosOrderNotifications         : 'PosOrderNotifications',

  TableDiscount               : 'TableDiscount',
  TableCancel                 : 'TableCancel',
  TableSetCustomPrice         : 'TableSetCustomPrice',
  TableTransactionManualAccept: 'TableTransactionManualAccept',

  OpenWaiterShift  : 'OpenWaiterShift',
  CloseWaiterShift : 'CloseWaiterShift',
  MovePayment      : 'MovePayment',
  ManageAllTables  : 'ManageAllTables',
  ChangeTableWaiter: 'ChangeTableWaiter',

  DocumentCancel   : 'DocumentCancel',
  TransactionRefund: 'TransactionRefund'
}

export default PinManagerEnum
